export function saveKeys(payload) {
  return {
    type: 'TREE_SELECT_KEYS',
    payload,
  };
}

export function setLevelData(payload) {
  return {
    type: 'TREE_LEVEL_DATA',
    payload,
  };
}

const intialGlobalInfo = {
  keys: [],
  levelData: [],
};

export default function treeKeys(state = intialGlobalInfo, action) {
  const { type, payload } = action;

  switch (type) {
    case 'TREE_SELECT_KEYS':
      return Object.assign({}, state, { keys: payload });
    case 'TREE_LEVEL_DATA':
      return Object.assign({}, state, { levelData: payload });
    default:
      return state;
  }
}
